import { Office } from "../models/office";

import BaseService from "./_base.service";

const ROUTE_NAME = "office";

const OfficeService = {
  ...BaseService<Office>({ endpoint: ROUTE_NAME }),
};

export default OfficeService;
